import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { BackButton } from "components/BackButton";
import { useLocation, useParams } from "react-router-dom";
import { useGetMembers } from "hooks/partnerApi/useGetMembers";
import AlpacaActivitiesScroll from "components/AlpacaActivitiesScroll";

export const MemberGlobalMarketHistoryPage: React.FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const location = useLocation();
  const initialFilters = location.state;

  const { data: members } = useGetMembers();
  const { name } = useMemo(() => {
    const member = members?.flat().find((member) => member.uid === uid);
    const memberName =
      member?.natural_person_data?.first_name +
        " " +
        member?.natural_person_data?.last_name || "";
    return {
      name: memberName,
    };
  }, [members, uid]);

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="mb-2 flex flex-row items-center justify-between border-b border-[--milkylb-color-secondary-100]">
        <div className="mb-8 flex flex-col items-start justify-normal">
          <BackButton className="mb-4" />
          <h1 className="font-['Tomato_Grotesk'] text-4xl font-bold">
            <FormattedMessage {...messages.title} values={{ name }} />
          </h1>
        </div>
      </div>
      <div className="flex h-full w-full flex-col">
        <AlpacaActivitiesScroll
          initialFilter={initialFilters}
          memberUid={uid}
          noChips
        />
      </div>
    </div>
  );
};
